function degreesToRadians(degrees) {
  var pi = Math.PI;
  return (degrees * (pi / 180)) / 4;
}

function measureAngle(cx, cy, ex, ey) {
  var dy = ey - cy;
  var dx = ex - cx;
  var theta = Math.atan2(dy, dx); // range (-PI, PI]
  return theta / Math.PI;
}

export { degreesToRadians, measureAngle };
